import React from 'react';

import classes from './NgzChallengePaymentTab.module.scss';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { angularizeWithProviders } from '../../../../shared/providers';
import { ConnectStripeWidget } from '../../../containers/ConnectStripeWidget/ConnectStripeWidget';
import { ChallengeTaxWidget } from '../../../containers/ChallengeTaxWidget/ChallengeTaxWidget';

type NgzChallengePaymentTabProps = {
  entityId: number;
  isStripeConnected: boolean;
};

const NgzChallengePaymentTab = ({
  entityId,
  isStripeConnected,
}: NgzChallengePaymentTabProps) => {
  const { isSuperAdmin } = loggedInUserDataStore;

  return (
    <div className={classes.row}>
      <ConnectStripeWidget
        entityId={entityId}
        isStripeConnected={isStripeConnected}
        disabled={isSuperAdmin}
      />
      <ChallengeTaxWidget entityId={entityId} />
    </div>
  );
};

angularizeWithProviders(NgzChallengePaymentTab, 'ngzChallengePaymentTab', {
  entityId: '<',
  isStripeConnected: '<',
});
